// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"128":"c558935a","239":"05960f8c","389":"7583e9de","732":"03592600","977":"dac22ca0"}[chunkId] + ".chunk.js";
};